import { useDispatch, useSelector } from 'react-redux'
import { editorThunks } from 'store/features/editor/thunks'
import { editorSelectors } from 'store/features/editor/selectors'
import { getDataByType } from './utils'
import { ErrorKeys } from 'consts/errorKeys'
import ErrorPopupContent from 'components/AlertPopups/ErrorPopup/ErrorPopupContent'

const ApiErrorPopup = () => {
  const { type, message = '' } = useSelector(editorSelectors.apiErrorPopupData)
  const dispatch = useDispatch()

  const onClose = () => {
    dispatch(editorThunks.resetApiErrorPopupData())
  }

  if (!type) {
    return null
  }

  const { description, title } = getDataByType(type as ErrorKeys)
  const _description = description || message

  return (
    <ErrorPopupContent
      isOpen={!!_description}
      description={_description}
      title={title}
      onClose={onClose}
      onButtonClick={onClose}
    />
  )
}

export default ApiErrorPopup
